import React from "react";

const LazyBackground = ({ src, className }) => {
  const [visible, setVisible] = React.useState(false);
  const ref = React.useRef();

  React.useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin: "200px" }
    );
    if (ref.current) observer.observe(ref.current);
  }, []);

  return (
    <div ref={ref}>
      {visible && <img src={src} alt="" className={className} loading="lazy" />}
    </div>
  );
};

export default LazyBackground;
